import locationsModal from './locations-modal'

async function getIsLocationGranted() {
    if (!navigator.permissions) return false
    try {
        const status = await navigator.permissions.query({ name: 'geolocation' })
        return status.state === 'granted'
    } catch (e) {
        return false
    }
}

async function handleCityBtnCard () {
    const isLocationGranted = await getIsLocationGranted()
    if (isLocationGranted) return
    window.dataLayer = window.dataLayer || []
    const $btn = $('#city-btn-card')

    $btn.attr('role', 'button')
    $btn.attr('data-id', 'Card_RainForecast_Link_UseLocation')
    $btn.off('click.cityBtnModal')[0].onclick =(e) => {
        e.preventDefault()
        locationsModal.open()
        window.dataLayer.push({ event: 'click_button', id: 'Card_RainForecast_Link_UseLocation' })
    }

}

const init = () => {

    handleCityBtnCard()
}

const cityBtnModal = { init }

export default cityBtnModal
